import React from 'react';
export function EmotionalCtaSection() {
  return <section aria-labelledby="emocional-title" className="border-b border-line bg-surface/40" data-id="element-67" data-mp="1hxeu0nvgc5bq">
      <div className="mx-auto max-w-xs px-5 py-10 text-center sm:max-w-xl sm:px-8 lg:py-14" data-id="element-68" data-mp="fxbwm3mwjzpz">
        <h2 id="emocional-title" className="mx-auto text-base font-black leading-snug tracking-tight text-accent sm:text-2xl" data-id="element-69" data-mp="jxdyacsn0t59">
          Tu hijo sigue queriendo estar cerca.
          <br data-id="element-70" data-mp="to8g94yup6kw" />
          Solo necesita que le enseñes cómo.
        </h2>
      </div>
    </section>;
}